// extracted by mini-css-extract-plugin
module.exports = {"slider":"WidgetProducts_slider___wCQK","sliderSlide":"WidgetProducts_slider-slide__aewdQ","item":"WidgetProducts_item__X6TEs"};